import HelpSingle from '../pages/help/partials/HelpSingle.vue';

export default [
  {
    path: ':slug',
    name: 'help.single',
    component: HelpSingle,
    meta: {
      public: true,
    },
  },
];
